import { Controller, useFormContext } from "react-hook-form";
import { makeStyles, TextField } from "@material-ui/core";
import { ErrorMessage } from "@hookform/error-message";

import { IProps } from "../../types/types";
import styles from "../../styles/DateField.module.scss";

const dateFieldStyles = makeStyles(() => ({
  root: {
    "& .MuiInputBase-root": {
      fontSize: "1.4rem",
      color: "#707072",
      fontFamily: "Montserrat",
      fontWeight: 500,
    },
  },
}));

export const DateField = ({ label, name, required, component }: IProps) => {
  const {
    register,
    trigger,
    control,
    formState: { errors },
  } = useFormContext();
  const stylesMui = dateFieldStyles();
  const errorMessage = required && "Este campo debe ser completado";

  return (
    <div className={styles.formItem}>
      <div style={{ marginBottom: "1.5rem" }}>
        <span>{label}</span>
      </div>

      <div className={styles.form}>
        <Controller
          control={control}
          {...register(name, {
            required: errorMessage,
          })}
          name={name}
          defaultValue=""
          render={({ field: { onChange, name, value } }) => (
            <TextField
              onKeyUp={() => trigger(name)}
              className={stylesMui.root}
              id={name}
              type={component.type}
              name={name}
              value={value}
              required={required}
              onChange={onChange}
              autoComplete={label}
              variant="standard"
            />
          )}
        />
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ message }) => (
            <span className={styles.form__error}>{message}</span>
          )}
        />
      </div>
    </div>
  );
};
